import React from "react"
import { Link, useLocation } from "react-router-dom"
import { saveNavigationState } from "~/utils/navigationState"

interface NavigationLinkProps {
  to: string
  children: React.ReactNode
  className?: string
  style?: React.CSSProperties
  onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void
  type: string
}

const NavigationLink: React.FC<NavigationLinkProps> = ({
  to,
  children,
  className,
  style,
  onClick,
  type,
  ...props
}) => {
  const location = useLocation()

  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    if (to.startsWith(`/${type}/`) && !to.includes("/edit")) {
      let currentTitle = document.title || "Current Page"

      const pageTitleElement =
        document.querySelector("h1.page-title") ||
        document.querySelector(".page-title") ||
        document.querySelector("h1") ||
        document.querySelector("[data-page-title]")

      if (pageTitleElement) {
        const titleText = pageTitleElement.textContent?.trim()
        if (titleText) {
          currentTitle = titleText.replace(/\s+/g, " ").trim()
        }
      }

      saveNavigationState(type, `${location.pathname}${location.search}`, currentTitle)
    }

    if (onClick) {
      onClick(event)
    }
  }

  return (
    <Link to={to} className={className} style={style} onClick={handleClick} {...props}>
      {children}
    </Link>
  )
}

export default NavigationLink
